import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "../../../../../../assets/images/icons/CloseIcon";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton";
import BriaIconButton from "../../../../../../components/common/BriaIconButton/BriaIconButton";
import RouterConstants from "../../../../../../constants/RouterConstants";
import styles from "./TgIntegrateModelBanner.module.scss";

const TgIntegrateModelBanner = () => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.integrateBanner" });
	const [isOpen, setIsOpen] = useState(true);

	const handleButtonClick = () => {
		window.open(RouterConstants.NEW_TG.ACCESS_METHODS.fullPath, "_blank");
	};

	return (
		isOpen && (
			<Box className={styles.root}>
				<Box className={styles.content}>
					<Typography className={styles.title}>{t("title")}</Typography>
					<Typography className={styles.description}>{t("description")}</Typography>
				</Box>
				<Box className={styles.actions}>
					<BriaButton buttonType="secondarySmall" onClick={handleButtonClick}>
						{t("button")}
					</BriaButton>
					<BriaIconButton onClick={() => setIsOpen(false)}>
						<CloseIcon />
					</BriaIconButton>
				</Box>
			</Box>
		)
	);
};

export default observer(TgIntegrateModelBanner);
